var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 341.39,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.61
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.61
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.61,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 170.78
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "222.434,170.574 125.359,170.574 121.314,146.306 226.479,146.306 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD350"
    },
    points: "124.347,164.507 125.359,170.574 222.434,170.574 223.446,164.507 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 171.87,
    y: 89.68,
    style: {
      fill: "#FFE15A"
    },
    width: 4.045,
    height: 16.179
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.83,
    y: 93.72,
    style: {
      fill: "#FFE15A"
    },
    width: 12.134,
    height: 4.045
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M222.75,154.395c-0.458,0-0.922-0.079-1.379-0.241c-2.099-0.762-3.186-3.081-2.423-5.182   l8.568-23.645c0.425-1.173,0.324-2.465-0.275-3.543c-0.318-0.573-1.063-1.58-2.481-1.884c-10.446-2.22-30.694-5.953-48.911-5.953   h-3.907c-18.218,0-38.465,3.733-48.915,5.957c-1.414,0.3-2.159,1.307-2.477,1.88c-0.598,1.078-0.699,2.37-0.273,3.543l8.566,23.645   c0.762,2.101-0.324,4.42-2.423,5.182c-2.097,0.751-4.422-0.328-5.18-2.425l-8.568-23.645c-1.223-3.373-0.93-7.098,0.804-10.223   c1.675-3.022,4.541-5.163,7.865-5.87c10.762-2.291,31.644-6.134,50.602-6.134h3.907c18.958,0,39.84,3.843,50.598,6.13   c3.328,0.711,6.194,2.852,7.868,5.874c1.734,3.124,2.026,6.849,0.806,10.223l-8.57,23.645   C225.958,153.372,224.404,154.395,222.75,154.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M173.912,150.856c-2.234,0-4.045-1.809-4.045-4.045v-32.864c0-2.236,1.811-4.045,4.045-4.045   s4.045,1.809,4.045,4.045v32.864C177.957,149.047,176.146,150.856,173.912,150.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M201.873,154.395c-0.273,0-0.549-0.028-0.826-0.083c-2.188-0.454-3.593-2.595-3.138-4.783   l4.906-23.645c0.638-3.081-0.361-5.779-0.928-6.253c-5.609-2.058-16.861-5.684-26.872-5.684h-2.238   c-10.011,0-21.263,3.626-27.079,5.791c-0.359,0.367-1.359,3.065-0.721,6.146l4.906,23.645c0.454,2.188-0.95,4.329-3.138,4.783   c-2.19,0.423-4.331-0.952-4.782-3.14l-4.906-23.645c-1.223-5.893,0.654-13.442,5.816-15.37c7.732-2.876,19.191-6.3,29.904-6.3   h2.238c10.712,0,22.172,3.425,29.9,6.296c5.167,1.932,7.043,9.48,5.82,15.374l-4.906,23.645   C205.434,153.084,203.749,154.395,201.873,154.395z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD350"
    },
    points: "122.325,152.373 225.468,152.373 226.479,146.306 121.314,146.306 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M97.045,170.574c-2.234,0-4.045,1.811-4.045,4.045v141.257c0,44.85,36.218,81.208,80.897,81.208  s80.897-36.358,80.897-81.208V174.619c0-2.234-1.811-4.045-4.045-4.045H97.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M181.986,304.054l8.09-20.224l-16.179,4.045l-16.179-4.045l8.09,20.224l-20.224,68.762  c0,0,12.134,8.09,28.314,8.09s28.314-8.09,28.314-8.09L181.986,304.054z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "144.601,320.356 137.465,322.139 153.163,293.882 146.092,289.956 127.025,324.278   109.179,324.278 109.179,332.368 117.871,332.368 106.653,341.342 111.705,347.662 121.235,340.039 117.476,351.312   125.151,353.872 132.539,331.708 146.564,328.2 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M145.583,211.023l-18.465-9.232c-3.391-1.696-5.15-5.519-4.23-9.198l1.044-4.177  c0.725-2.899-1.468-5.707-4.456-5.707c-1.395,0-2.715,0.634-3.586,1.724c-9.581,11.976-14.8,26.856-14.8,42.193v85.518  c0,0,16.891-3.378,32.149-25.57c2.802-4.075,7.413-6.486,12.328-6.739l-8.073,24.219l16.179,4.045l14.157-16.847L145.583,211.023z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "203.192,320.356 210.328,322.139 194.63,293.882 201.701,289.956 220.769,324.278   238.614,324.278 238.614,332.368 229.922,332.368 241.14,341.342 236.088,347.662 226.558,340.039 230.317,351.312 222.642,353.872   215.254,331.708 201.229,328.2 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M202.21,211.023l18.465-9.232c3.391-1.696,5.15-5.519,4.23-9.198l-1.044-4.177  c-0.725-2.899,1.468-5.707,4.456-5.707c1.395,0,2.715,0.634,3.586,1.724c9.581,11.976,14.8,26.856,14.8,42.193v85.518  c0,0-16.891-3.378-32.149-25.57c-2.802-4.075-7.413-6.486-12.328-6.739l8.073,24.219l-16.179,4.045l-14.157-16.847L202.21,211.023z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "149.628,182.709 129.403,182.709 135.471,190.799 149.628,194.843 141.538,198.888    153.672,198.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "198.166,182.709 218.39,182.709 212.322,190.799 198.166,194.843 206.255,198.888    194.121,198.888  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M201.013,179.538l-19.027,3.171l-8.09,16.179l-8.09-16.179l-19.027-3.171  c-2.182-0.364-3.854,1.901-2.865,3.879l9.758,19.516l-8.09,8.09h28.314h28.314l-8.09-8.09l9.758-19.516  C204.867,181.439,203.195,179.174,201.013,179.538z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFBE50"
    },
    cx: 173.9,
    cy: 148.07,
    r: 6.067
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#41479B"
    },
    cx: 173.81,
    cy: 162.57,
    rx: 4.795,
    ry: 3.371
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF4B55"
    },
    cx: 149.88,
    cy: 162.57,
    rx: 4.795,
    ry: 3.371
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#41479B"
    },
    cx: 125.95,
    cy: 162.57,
    rx: 4.795,
    ry: 3.371
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#41479B"
    },
    cx: 221.68,
    cy: 162.57,
    rx: 4.795,
    ry: 3.371
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF4B55"
    },
    cx: 197.74,
    cy: 162.57,
    rx: 4.795,
    ry: 3.371
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFBE50"
    },
    cx: 202,
    cy: 148.07,
    r: 6.067
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFBE50"
    },
    cx: 224.19,
    cy: 148.07,
    r: 6.067
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFBE50"
    },
    cx: 145.81,
    cy: 148.07,
    r: 6.067
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFBE50"
    },
    cx: 123.62,
    cy: 148.07,
    r: 6.067
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M180.864,113.947c0.695-1.194,1.122-2.564,1.122-4.045c0-4.468-3.622-8.09-8.09-8.09  s-8.09,3.622-8.09,8.09c0,1.481,0.427,2.851,1.122,4.045C166.928,113.947,180.864,113.947,180.864,113.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M173.897,293.942c-16.728,0-30.336-13.608-30.336-30.336V209h60.672v54.605  C204.233,280.334,190.625,293.942,173.897,293.942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A54B50"
    },
    d: "M202.21,211.023v52.583c0,15.637-12.676,28.314-28.314,28.314s-28.314-12.677-28.314-28.314v-52.583  L202.21,211.023 M206.255,206.978h-4.045h-56.628h-4.045v4.045v52.583c0,17.843,14.516,32.359,32.359,32.359  s32.359-14.516,32.359-32.359v-52.583V206.978L206.255,206.978z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M167.829,291.251c1.956,0.428,3.983,0.668,6.067,0.668c2.085,0,4.111-0.24,6.067-0.668v-80.229   h-12.134V291.251z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.58,
    y: 244.39,
    style: {
      fill: "#F5F5F5"
    },
    width: 56.628,
    height: 12.134
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRs);
export default __webpack_public_path__ + "static/media/RS.a008bc5e5d1295aa22640ece71a460d5.svg";
export { ForwardRef as ReactComponent };